import { createElement } from 'react';
import { ListItemType, useScheduleContext, } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
import { AudioMessage } from './components/audioMessage/audioMessage';
import { AutoReply } from './components/autoReply/autoReply';
import { OpeningHours } from './components/openingHours/openingHours';
const regularName = 'Outside business hours';
const listItem = {
    hours: OpeningHours,
    audioMessages: AudioMessage,
    autoReplies: AutoReply,
};
export const ListItem = ({ index, item }) => {
    const { id, overridden_by, opening_hour_type: openingHourType } = item;
    const isRegular = openingHourType === 'regular';
    const { activeView: { menu: activeMenu }, conflicts, listItems, } = useScheduleContext();
    const hasConflict = !isRegular && id in conflicts;
    // Whether the opening hour is already overridden by another item
    const overrideException = (!isRegular &&
        overridden_by &&
        listItems[ListItemType.Exception].find(({ id }) => id === (overridden_by === null || overridden_by === void 0 ? void 0 : overridden_by.id))) ||
        null;
    const props = Object.assign({ hasConflict,
        index, openingHours: item, overrideException: hasConflict ? null : overrideException }, (activeMenu !== 'hours' && isRegular && { name: regularName }));
    return createElement(listItem[activeMenu], props);
};
